import { AvatarGroupInLine, Box, type IColumn, Typography } from 'shared/ui'
import { type TeamRow } from 'entities/Teams/model/TeamRow'

export const columns = (): IColumn<TeamRow>[] => {
  const columns: IColumn<TeamRow>[] = [
    {
      field: 'name',
      name: 'Name',
      width: '46.8%',
      isSortable: true,
      renderRowCell: (row) => {
        return (
          <Box
            display='flex'
            alignItems='start'
            gap={'8px'}
            flexDirection='column'
            minHeight='56px'
            justifyContent='center'
          >
            <Typography
              ellipsis
              tag='div'
              variant={'body-md-regular'}
              ariaLabel='teamName'
              width='100%'
            >
              {row.name}
            </Typography>
            {row.description && (
              <Typography
                width='100%'
                ellipsis
                variant={'body-sm-regular'}
                color='tertiary'
                ariaLabel='teamDescription'
                tooltipProps={{
                  label: row.description,
                }}
              >
                {row.description}
              </Typography>
            )}
          </Box>
        )
      },
    },
    {
      field: 'members',
      name: 'Members',
      width: '172px',
      isSortable: true,
      renderRowCell: (row) => {
        return (
          <Box display='flex' alignItems='center' gap={'8px'} minHeight='56px'>
            {row.hasMembers && <AvatarGroupInLine items={row.membersInfo} size={16} />}
            <Typography variant={'body-md-regular'} ariaLabel='teamMembers'>
              {row.membersCount} member{row.membersCount !== 1 ? 's' : ''}
            </Typography>
          </Box>
        )
      },
    },
    {
      field: 'source',
      name: 'Source',
      isSortable: true,
      renderRowCell: (row) => {
        return (
          <Box minHeight='56px' display='flex' alignItems='center'>
            <Typography
              ellipsis
              tag='div'
              variant={'body-md-regular'}
              ariaLabel='teamName'
              width='100%'
            >
              {row.source}
            </Typography>
          </Box>
        )
      },
    },
  ]

  return columns
}
